var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_769_11683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_769_11683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00011 10.9668C7.91122 10.9668 7.82511 10.9501 7.74178 10.9168C7.65844 10.8835 7.57789 10.8279 7.50011 10.7501L4.48344 7.73348C4.35011 7.60015 4.289 7.43348 4.30011 7.23348C4.31122 7.03348 4.37789 6.87237 4.50011 6.75015C4.64455 6.6057 4.81122 6.53626 5.00011 6.54181C5.189 6.54737 5.35011 6.61681 5.48344 6.75015L8.00011 9.28348L10.5334 6.75015C10.6668 6.61681 10.8251 6.55015 11.0084 6.55015C11.1918 6.55015 11.3557 6.62237 11.5001 6.76681C11.6334 6.90015 11.7001 7.06403 11.7001 7.25848C11.7001 7.45292 11.6334 7.61681 11.5001 7.75015L8.50011 10.7501C8.42233 10.8279 8.34178 10.8835 8.25844 10.9168C8.17511 10.9501 8.089 10.9668 8.00011 10.9668Z",
    fill: "#D3135A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownarrow);
export default __webpack_public_path__ + "static/media/dropdownarrow.7a70446c370c938de525168a390698fc.svg";
export { ForwardRef as ReactComponent };